var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fly"}},[(_vm.isError)?_c('div',{class:['warning', _vm.isError ? 'error-notif' : '']},[_c('p',[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }